import React from 'react';
import { Helmet } from 'react-helmet';

const AboutPage: React.FC = () => {
  return (
    <div className="space-y-6">
      <Helmet>
        <title>Despre noi</title>
      </Helmet>

      <div className="space-y-2">
        <h1 className="text-2xl font-semibold">Despre noi</h1>
        <p className="text-sm text-muted-foreground">
          Informații generale (branding și domeniu în curs de stabilire).
        </p>
      </div>

      <section className="rounded-lg border border-border bg-card p-4 text-sm">
        <div className="font-semibold">Global Linknet SRL</div>
        <div className="mt-2 space-y-1 text-muted-foreground">
          <div>
            Sediu: județul Argeș, Pitești, Str. Dorobanților, nr. 14, bl. 51, et. 1, ap. 8
          </div>
          <div>Registrul Comerțului: J03/1287/2023</div>
          <div>CUI: 48291648</div>
          <div>
            E-mail: <span className="text-foreground">office@globallinknet.ro</span>
          </div>
        </div>
      </section>

      <section className="space-y-3 text-sm text-muted-foreground">
        <h2 className="text-lg font-semibold text-foreground">Misiune</h2>
        <p>
          Construim o platformă educațională care simplifică administrarea unei clase sau a unei școli întregi:
          comunicare, catalog, absențe, orar, materiale și colaborare — într-un singur loc, cu accent pe securitate și
          experiență ușor de folosit.
        </p>
      </section>

      <section className="space-y-3 text-sm text-muted-foreground">
        <h2 className="text-lg font-semibold text-foreground">Pentru cine este</h2>
        <ul className="list-disc pl-5 space-y-2">
          <li>
            <span className="text-foreground">B2C</span>: utilizare individuală (ex. o clasă) pe bază de cont/abonament,
            după caz.
          </li>
          <li>
            <span className="text-foreground">B2B</span>: implementare la nivel de unitate de învățământ, pe baza unei
            oferte/contract.
          </li>
        </ul>
      </section>

      <section className="space-y-3 text-sm text-muted-foreground">
        <h2 className="text-lg font-semibold text-foreground">Sugestii & suport</h2>
        <p>
          Pentru sugestii sau probleme întâmpinate, folosește pagina de Contact (poți atașa capturi de ecran și fișiere).
        </p>
      </section>
    </div>
  );
};

export default AboutPage;

